import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import ModalRiwayatIuran from 'components/pages/modal/participant/peserta/riwayatIuran'
import ModalRiwayatKlaim from 'components/pages/modal/participant/peserta/riwayatKlaim'
import ModalClientStatement from 'components/pages/modal/participant/peserta/clientStatement'
import { productDefault } from 'dataSource/lookup'
import { confirmAlert } from 'react-confirm-alert'

class DaftarPesertaAktif extends Component {
  constructor(props) {
    super(props)

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0

    this.dataGridRef = React.createRef()
    this.modalRiwayatIuranRef = React.createRef()
    this.modalRiwayatKlaimRef = React.createRef()
    this.modalClientStatementRef = React.createRef()

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Riwayat Iuran',
            hint: 'edit',
            onClick: (e) => {
              this.modalRiwayatIuranRef.current.show()
              this.modalRiwayatIuranRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Riwayat Klaim',
            hint: 'edit',
            onClick: (e) => {
              this.modalRiwayatKlaimRef.current.show()
              this.modalRiwayatKlaimRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Client Statement',
            hint: 'edit',
            onClick: (e) => {
              this.modalClientStatementRef.current.show()
              this.modalClientStatementRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Pengkinian Peserta',
            hint: 'edit',
            onClick: (e) => {
              confirmAlert({
                title: 'Konfirmasi',
                message:
                  'Apakah Anda yakin ingin melakukan pengkinian peserta?',
                overlayClassName: 'react-custom-confirm-alert-overlay',
                buttons: [
                  {
                    label: 'Iya',
                    onClick: () => {
                      console.log('Yes')
                    },
                  },
                  {
                    label: 'Batal',
                    onClick: () => {
                      console.log('No')
                    },
                  },
                ],
              })
            },
          },
          {
            text: 'Status Peserta',
            hint: 'edit',
            onClick: (e) => {
              confirmAlert({
                title: 'Konfirmasi',
                message:
                  'Apakah Anda yakin ingin melakukan pengkinian status peserta?',
                overlayClassName: 'react-custom-confirm-alert-overlay',
                buttons: [
                  {
                    label: 'Iya',
                    onClick: () => {
                      console.log('Yes')
                    },
                  },
                  {
                    label: 'Batal',
                    onClick: () => {
                      console.log('No')
                    },
                  },
                ],
              })
            },
          },
        ],
      },
      // {
      //   dataField: 'kpId',
      //   caption: 'KP Id',
      // },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'fullName',
        caption: 'Nama Karyawan',
      },
      {
        dataField: 'productId',
        caption: 'Produk',
        lookup: {
          dataSource: productDefault(this.props.store),
          valueExpr: 'id',
          displayExpr: 'productName',
        },
        groupIndex: 0,
      },
      {
        dataField: 'birthDate',
        caption: 'Tanggal Lahir',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'tanggalEfektifPegawai',
        caption: 'Tanggal Efektif',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'tanggalEfektifAkun',
        caption: 'Tanggal Efektif Kepesertaan',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'iuran',
        caption: 'IURAN',
        alignment: 'center',
        columns: [
          {
            dataField: 'iuranAmount',
            caption: 'Total Iuran',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'iuranUnit',
            caption: 'Total Unit',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
        ],
      },
      {
        dataField: 'klaim',
        caption: 'KLAIM',
        alignment: 'center',
        columns: [
          {
            dataField: 'klaimUnit',
            caption: 'Total Unit',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'klaimAmount',
            caption: 'Nominal Klaim',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
        ],
      },
      {
        dataField: 'saldoAkhir',
        caption: 'SALDO AKHIR',
        alignment: 'center',
        columns: [
          {
            dataField: 'saldoUnit',
            caption: 'Total Unit',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'navDate',
            caption: 'Tanggal Aktiva',
            dataType: 'date',
            format: 'dd MMM yyyy',
          },
          {
            dataField: 'navValue',
            caption: 'Aktiva Bersih/Unit',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'saldoNominal',
            caption: 'Nominal Saldo',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
        ],
      },
    ]

    this.sumGroup = [
      {
        column: 'id',
        summaryType: 'count',
        displayFormat: 'Jumlah: {0}',
      },
      {
        column: 'iuranAmount',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'iuranAmount',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
      {
        column: 'iuranUnit',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'iuranUnit',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
      {
        column: 'klaimUnit',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'klaimUnit',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
      {
        column: 'klaimAmount',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'klaimAmount',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
      {
        column: 'saldoUnit',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'saldoUnit',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
      {
        column: 'navValue',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'navValue',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
      {
        column: 'saldoNominal',
        summaryType: 'sum',
        valueFormat: '#,##0.00',
        name: 'saldoNominal',
        displayFormat: 'Total: {0}',
        showInGroupFooter: true,
        alignByColumn: true,
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <div className="container-fluid">
        <h2 className="main-title">Daftar Peserta Aktif</h2>

        <DevExpressDataGrid
          ref={this.dataGridRef}
          loadAPI={`wp/pesertas/aktif?participantId.equals=${this.participantId}`}
          insertAPI="wp/pesertas/aktif"
          updateAPI="wp/pesertas/aktif"
          deleteAPI="wp/pesertas/aktif"
          backendserver={process.env.REACT_APP_BACKEND_CORE}
          remoteOperations={true}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}
          exportExcel={false}
          exportFileName={'Daftar Peserta Aktif'}
          allowExportSelectedData={true}
          selection={'single'}
          showBorders={true}
          paging={true}
          defaultPageSize={20}
          height={'80vh'}
          popupTitle={'Daftar Peserta Aktif'}
          popupWidth={700}
          popupHeight={500}
          popupFormLabelLocation="left"
          popupFormMinColWidth={300}
          popupFormColCount={3}
          ColumnChooser={true}
          ColumnFixing={true}
          FilterRow={true}
          ColumnConfiguration={this.columns}
          grouping={true}
          groupSummary={this.sumGroup}
          onToolbarPreparing={this.onToolbarPreparing}
          autoExpandAll={true}
          store={this.props.store}
        />

        <ModalRiwayatIuran
          ref={this.modalRiwayatIuranRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
        <ModalRiwayatKlaim
          ref={this.modalRiwayatKlaimRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
        <ModalClientStatement
          ref={this.modalClientStatementRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
      </div>
    )
  }
}

export default DaftarPesertaAktif
